"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/cosmic/background-svg-patterns.tsx
import { motion } from "framer-motion";
import { useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function BackgroundSvgPatterns({
  colorScheme: _colorScheme,
  intensity: _intensity
}) {
  const id = useId();
  const diagonalLinesId = `${id}-diagonalLines`;
  const hexPatternId = `${id}-hexPattern`;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      height: "100%",
      xmlns: "http://www.w3.org/2000/svg",
      className: "absolute inset-0",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          "pattern",
          {
            id: diagonalLinesId,
            patternUnits: "userSpaceOnUse",
            width: "40",
            height: "40",
            patternTransform: "rotate(45)",
            children: /* @__PURE__ */ jsx("line", { x1: "0", y1: "0", x2: "0", y2: "\
40", stroke: "rgba(99, 102, 241, 0.1)", strokeWidth: "1" })
          }
        ),
        /* @__PURE__ */ jsx("rect", { x: "0", y: "0", width: "100%", height: "10\
0%", fill: `url(#${diagonalLinesId})` }),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: "85%",
            cy: "15%",
            r: "150",
            fill: "rgba(224, 231, 255, 0.6) dark:rgba(67, 56, 202, 0.15)"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: "80%",
            cy: "10%",
            r: "80",
            fill: "rgba(199, 210, 254, 0.4) dark:rgba(55, 48, 163, 0.2)"
          }
        ),
        /* @__PURE__ */ jsx(
          "polygon",
          {
            points: "10,85 25,70 40,85 25,100",
            fill: "rgba(165, 180, 252, 0.4) dark:rgba(79, 70, 229, 0.25)"
          }
        ),
        /* @__PURE__ */ jsx(
          "polygon",
          {
            points: "5,90 15,80 25,90 15,100",
            fill: "rgba(129, 140, 248, 0.3) dark:rgba(99, 102, 241, 0.2)"
          }
        ),
        /* @__PURE__ */ jsx(
          motion.circle,
          {
            cx: "20%",
            cy: "30%",
            r: "3",
            fill: "rgba(99, 102, 241, 0.4)",
            animate: {
              cy: ["30%", "25%", "30%"],
              opacity: [0.4, 0.6, 0.4]
            },
            transition: {
              duration: 4,
              repeat: Number.POSITIVE_INFINITY,
              ease: "easeInOut"
            }
          }
        ),
        /* @__PURE__ */ jsx(
          motion.circle,
          {
            cx: "75%",
            cy: "60%",
            r: "2",
            fill: "rgba(129, 140, 248, 0.5)",
            animate: {
              cx: ["75%", "78%", "75%"],
              opacity: [0.5, 0.3, 0.5]
            },
            transition: {
              duration: 6,
              repeat: Number.POSITIVE_INFINITY,
              ease: "easeInOut"
            }
          }
        ),
        /* @__PURE__ */ jsx("pattern", { id: hexPatternId, x: "0", y: "0", width: "\
60", height: "52", patternUnits: "userSpaceOnUse", children: /* @__PURE__ */ jsx(
          "polygon",
          {
            points: "30,2 52,16 52,38 30,52 8,38 8,16",
            fill: "none",
            stroke: "rgba(99, 102, 241, 0.1)",
            strokeWidth: "1"
          }
        ) }),
        /* @__PURE__ */ jsx("rect", { x: "0", y: "0", width: "100%", height: "10\
0%", fill: `url(#${hexPatternId})`, opacity: "0.3" })
      ]
    }
  );
}
__name(BackgroundSvgPatterns, "BackgroundSvgPatterns");
export {
  BackgroundSvgPatterns
};
